import { useDict, useFischer } from '@/composables/fischerPlugin';

interface SitecoreSellingUnitLanguage {
  Name: string;
}

export interface SitecoreSellingUnit {
  Code: string;
  DisplayName: string;
  Id: string;
  Language: SitecoreSellingUnitLanguage;
  Name: string;
  Name_Short: string;
  Url: string;
}

export const useSellingUnits = () => {
  const fischer = useFischer();
  const dict = useDict();

  const getSellingUnitsArray = (): SitecoreSellingUnit[] => {
    const { sellingUnits } = fischer.shopSettings();
    const sellingUnitsObject =
      typeof sellingUnits === 'object' ? Object.values(sellingUnits) : sellingUnits;

    return sellingUnitsObject.filter((unit: any) => unit !== null);
  };

  const getSellingUnit = (code: string) => {
    const sellingUnits = getSellingUnitsArray();

    const sellingUnit = sellingUnits.find((el: SitecoreSellingUnit) => el?.Code === code);

    if (sellingUnit?.Name_Short) {
      return sellingUnit.Name_Short;
    }

    return code;
  };

  const getSellingUnitLong = (code: string) => {
    const sellingUnits = getSellingUnitsArray();

    if (sellingUnits) {
      const sellingUnit = sellingUnits.find((el: SitecoreSellingUnit) => el?.Code === code);

      if (sellingUnit?.Name) {
        return sellingUnit.Name;
      }
    }

    return code;
  };

  const getSellingUnitInString = (unitString: string) => {
    let formattedUnitString = unitString;

    const sellingUnits = getSellingUnitsArray();
    if (sellingUnits) {
      sellingUnits.forEach((unit: any) => {
        if (!(unit?.Code && unit.Name_Short)) {
          return;
        }
        const reg = new RegExp(`\\b${unit.Code}\\b`);
        if (reg.test(formattedUnitString)) {
          formattedUnitString = unitString.replace(unit.Code, unit.Name_Short);
        }
      });
    }

    return formattedUnitString;
  };

  const getSellingPackage = (unitString: string | null | undefined): string => {
    if (unitString) {
      if (unitString === 'ST') {
        return dict.get('online-Shop.Product.Pack');
      }
      return (
        getSellingUnitsArray().find((el: SitecoreSellingUnit) => el?.Code === unitString)?.Name ||
        dict.get('online-Shop.Product.Pack')
      );
    }
    return '';
  };

  return {
    getSellingUnitsArray,
    getSellingUnit,
    getSellingUnitInString,
    getSellingUnitLong,
    getSellingPackage,
  };
};
